export { default } from "./plan.svelte";
